import type * as Types from 'app/types/graphql';

import { PageSnapshotSelectFragmentDoc } from '../fragments/pageSnapshots.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type PageSnapshotsQueryVariables = Types.Exact<{
  where: Types.PageSnapshotWhereInput;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  orderBy?: Types.InputMaybe<Types.PageSnapshotOrder>;
}>;

export type PageSnapshotsQueryResponse = {
  pageSnapshots?: Types.Maybe<{
    edges?: Types.Maybe<
      Array<
        Types.Maybe<{
          node?: Types.Maybe<
            Pick<
              Types.PageSnapshot,
              'hash' | 'presignedURL' | 'thumbnail' | 'createdAt' | 'campaignVariantType'
            >
          >;
        }>
      >
    >;
  }>;
};

export const PageSnapshotsDocument = `
    query PageSnapshots($where: PageSnapshotWhereInput!, $first: Int, $after: Cursor, $orderBy: PageSnapshotOrder) {
  pageSnapshots(where: $where, first: $first, after: $after, orderBy: $orderBy) {
    edges {
      node {
        ...PageSnapshotSelect
      }
    }
  }
}
    ${PageSnapshotSelectFragmentDoc}`;

export const usePageSnapshotsQuery = <TData = PageSnapshotsQueryResponse, TError = unknown>(
  variables: PageSnapshotsQueryVariables,
  options?: UseQueryOptions<PageSnapshotsQueryResponse, TError, TData>,
) => {
  return useQuery<PageSnapshotsQueryResponse, TError, TData>(
    ['PageSnapshots', variables],
    appFetcher<PageSnapshotsQueryResponse, PageSnapshotsQueryVariables>(
      PageSnapshotsDocument,
      variables,
    ),
    options,
  );
};

usePageSnapshotsQuery.getKey = (variables: PageSnapshotsQueryVariables) => [
  'PageSnapshots',
  variables,
];
